import { Injectable } from '@angular/core';
import { utils } from "@bayclubs/utils"
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { camps } from '../../models/models.generated';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils';
import * as fileSaver from 'file-saver';

@Injectable()
export class CouponApiService {

    constructor(private http: ApiHttpClient) { }

    public search(request: camps.CouponSearchRequest): Observable<api.OperationPagedResult<camps.CouponInfo>> {
        return this.http.post<api.OperationPagedResult<camps.CouponInfo>>("coupon/search", request, false);
    }

    public generate(request: camps.CouponGenerateRequest): Observable<api.OperationResultValue<camps.CouponInfo>> {
        return this.http.post<api.OperationResultValue<camps.CouponInfo>>("coupon/generate", request, true);
    }

    public deactivate(request: camps.CouponDeactivateRequest): Observable<api.OperationResultValue<camps.CouponInfo>> {
        return this.http.post<api.OperationResultValue<camps.CouponInfo>>("coupon/deactivate", request, true);
    }

    public activate(request: camps.CouponActivateRequest): Observable<api.OperationResultValue<camps.CouponInfo>> {
        return this.http.post<api.OperationResultValue<camps.CouponInfo>>("coupon/activate", request, true);
    }

    public details(request: camps.CouponDetailsRequest): Observable<api.OperationResultValue<camps.CouponInfo>> {
        return this.http.post<api.OperationResultValue<camps.CouponInfo>>("coupon/details", request, true);
    }

    public context(): Observable<api.OperationResultValue<camps.CouponsContext>> {
        return this.http.get<api.OperationResultValue<camps.CouponsContext>>("coupon/context", true);
    }

    public history(request: camps.CouponHistoryRequest): Observable<api.OperationPagedResult<camps.CouponHistoryItemInfo>> {
        return this.http.post<api.OperationPagedResult<camps.CouponHistoryItemInfo>>("coupon/history", request, false);
    }

    public getCouponReport(request: camps.CouponSearchRequest) {
        this.http.postFileRequest('coupon/report',request)
            .subscribe((responseSuccess: any) => {

                var blob = new Blob([responseSuccess], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, this.buildFileName(request.dateFrom,request.dateTo,'CouponReport'));

            }, () => {
               // this.alert.showError("File not found.")
            });
    }

    private buildFileName(dateFrom: utils.BcDate, dateTo: utils.BcDate, filePrefix : string){
        if(dateFrom && dateTo){
            return `${filePrefix}_${dateFrom.value}_${dateTo.value}.xlsx`;
        }

        if(dateFrom){
            return `${filePrefix}_from_${dateFrom.value}.xlsx`;
        }

        if(dateTo){
            return `${filePrefix}_to_${dateTo.value}.xlsx`;
        }

        return `${filePrefix}.xlsx`;
    }
}
